import Dialog from '@mui/material/Dialog';
import React from 'react';
import { useMobile } from '@/hooks/useMobile';
import type { SxProps } from '@mui/material/styles';

interface Props {
  onClose: () => void;
  children?: any;
}

const DIALOG_SX: SxProps = {
  zIndex: 20000,
};
const DIALOG_DESKTOP_SX: SxProps = {
  ...DIALOG_SX,
};
const DIALOG_MOBILE_SX: SxProps = {
  zIndex: 20000,
  margin: '16px',
};

const PAPER_SX: SxProps = {
  boxSizing: 'border-box',
  backgroundImage: 'unset',
  backgroundColor: 'var(--olymp-robot-background, #151d28)',
  gap: '24px',
  padding: '16px',
};
const PAPER_DESKTOP_SX: SxProps = {
  ...PAPER_SX,
  width: '320px',
  maxWidth: '320px',
};
const PAPER_MOBILE_SX: SxProps = {
  ...PAPER_SX,
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  maxWidth: '100%',
  margin: 0,
};

const Modal: React.FC<Props> = ({ onClose, children }) => {
  const isMobile = useMobile();

  return (
    <Dialog
      open
      sx={isMobile ? DIALOG_MOBILE_SX : DIALOG_DESKTOP_SX}
      PaperProps={{
        sx: isMobile ? PAPER_MOBILE_SX : PAPER_DESKTOP_SX,
      }}
      onClose={onClose}
    >
      {children}
    </Dialog>
  );
};

export default React.memo(Modal);
